import React from 'react';
import successGif from '../../images/success2.gif'
import "./Success&ErrorPopups.css"
import { Button, Modal, ModalBody } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { linkRedirectAction, successInfoAction, successModalToggle } from '../../redux/actions/Index';
import { NavLink } from 'react-router-dom';

function SuccessPopups() {
    const successpopup = useSelector((state)=>state?.ModalReducer?.successToggle);
    const successinfo = useSelector((state)=>state?.ModalReducer?.successinfo);
    const linkRedirect = useSelector((state)=>state?.ModalReducer?.linkRedirect);

    const dispatch = useDispatch()
    return (
        <div>
            <Modal isOpen={successpopup} className="modal-style">
                <ModalBody className="py-0">
                    <div className="d-flex justify-content-center align-items-center flex-column gap-3">
                        <div className="cards-img-success mb-2">
                            <img src={successGif} alt="SuccessGif" className="img-fit" />
                        </div>
                        <h1 className="title-font-bold fs-2 mb-2 text-uppercase text-base-color ">Success !</h1>
                        <label className="mb-2 fs-4 text-center text-capitalize  base-font-700 px-5">{successinfo}</label>
                        <div className="d-flex align-items-center gap-5">
                        <Button className='rounded-pill px-5 py-3 buttons bg-danger mt-2' onClick={()=>{dispatch(successModalToggle());dispatch(linkRedirectAction());dispatch(successInfoAction(""))}}><span className='fs-4 d-flex gap-3 title-font-400 '>Close</span></Button>
                        {linkRedirect && <NavLink className='rounded-pill px-5 py-3 buttons mt-2 text-decoration-none' to={linkRedirect} onClick={()=>{dispatch(successModalToggle());dispatch(linkRedirectAction());dispatch(successInfoAction(""))}}><span className='fs-4 d-flex gap-3 title-font-400 '>Yes</span></NavLink>}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default SuccessPopups;